export const formBaseTheme = {
  fonts: {},
};
